import React, { Component } from 'react';
import { withRouter } from '../../WithRouterHOC';
import { Steps, Modal, message, Button } from 'antd';
import { UpOutlined, DownOutlined, CheckCircleFilled } from '@ant-design/icons';
import HTTP from '../../../script/service';
import './ChangePhone.scss';
import NationCode from '../../nationCode/nationCode';
import Util from '../../../script/util';
import { _get_user_info } from '../../../store/Action';
import jxCaptchaVerifiedHOC from '../../jxCaptchaVerifiedHOC';

class ChangePhone extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      loading: false,
      current: 0,
      time: 0,
      param: {},
      nationVisible: false,
      nationCode: '86',
    };
  }
  showModal = (current) => {
    if (current === 0) {
      this.setState({
        nationCode: this.props.user?.userBindPhoneVo?.areaCode || '86',
      });
    }
    this.setState({
      visible: true,
      loading: false,
      current: current || 0,
    });
  };
  hideModal = () => {
    this.setState({ visible: false, time: 0 });
    clearTimeout(this.ttimer);
    this.props.destroyCaptchaVerified();
  };
  //发送验证码
  sendCode = async () => {
    const {
      base,
      user,
      initCaptchaVerified,
      getCaptchaVerified,
      resetCaptchaVerified,
    } = this.props;
    const { rootConfig } = base;
    const { userBindPhoneVo } = user;
    const { time, current, param, nationCode } = this.state;
    if (time) return false;
    let phone = userBindPhoneVo.phone;
    if (current === 1) {
      phone = param.phone;

      if (!Util.validationPhone(phone, nationCode)) return;
    }
    if (getCaptchaVerified()) {
      // 重新获取验证码需要重置验证码
      resetCaptchaVerified();
      await Util.sleep(300);
    }

    this.setState({ loading: true }, () => {
      initCaptchaVerified({ phone, nationCode }, () => {
        const params = {
          phone,
          clientIp: '127.0.0.1',
          type: 2,
        };
        if (rootConfig.lang !== 'zh_CN') {
          params.areaCode = nationCode;
        }
        const geeValidate = getCaptchaVerified();
        HTTP._send_code({ ...params, ...geeValidate })
          .then((res) => {
            if (res?.code == 200) {
              this.setState({ time: 60 }, () => {
                this.changeCodeTime();
              });
            } else {
              message.error(res?.message ?? '验证码发送失败，请稍后重试');
              if (res?.code === 5502) {
                resetCaptchaVerified();
              }
            }
          })
          .finally(() => {
            this.setState({ loading: false });
          });
      });
    });
  };
  //改变时间
  changeCodeTime = () => {
    let { visible, time } = this.state;
    if (!visible) return;
    if (time <= 0) return;
    this.setState({ time: time - 1 }, () => {
      this.ttimer = setTimeout(this.changeCodeTime, 1000);
    });
  };
  validatePhone = () => {
    const {
      base,
      getCaptchaVerified,
      resetCaptchaVerified,
      destroyCaptchaVerified,
    } = this.props;
    const { rootConfig, uid } = base;
    const { param, nationCode } = this.state;
    if (!param.code) {
      message.warning('请正确填写手机验证码');
      return false;
    }

    if (!getCaptchaVerified()) {
      message.warning('请重新获取验证码');
      return;
    }
    this.setState({ loading: true }, () => {
      const params = {
        lang: rootConfig.lang,
        uid,
        code: param.code,
      };
      if (rootConfig.lang !== 'zh_CN') {
        params.areaCode = nationCode;
      }
      const geeValidate = getCaptchaVerified();
      HTTP._phone_code_verify({ ...params, ...geeValidate })
        .then((res) => {
          if (res?.code === 200) {
            this.setState({ current: 1, time: 0 });
            destroyCaptchaVerified();
          } else {
            message.error(res?.message ?? '操作失败，请稍后重试~');
            if (res?.code === 5502) {
              // 验证码失效，请重新获取
              resetCaptchaVerified();
            }
          }
        })
        .finally(() => {
          this.setState({ loading: false });
        });
    });
  };
  changeFormValue = (e) => {
    let { param } = this.state;
    param[e.target.name] = e.target.value;
    this.setState({
      param: param,
    });
  };
  //绑定手机
  bindMePhone = () => {
    const { base, getCaptchaVerified, resetCaptchaVerified } = this.props;
    const { rootConfig, uid, token } = base;
    const { param, nationCode } = this.state;
    if (!this.validationData(nationCode)) return;
    if (!param.code) {
      message.warning('请正确填写手机验证码');
      return false;
    }
    if (!getCaptchaVerified()) {
      message.warning('请重新获取验证码');
      return;
    }
    this.setState({ loading: true }, () => {
      const params = {
        lang: rootConfig.lang,
        uid,
        phone: param.phone,
        code: param.code,
        ifAuth: 1,
      };
      if (rootConfig !== 'zh_CN') {
        params.areaCode = nationCode;
      }
      const geeValidate = getCaptchaVerified();
      HTTP._v2_bind_phone({ ...params, ...geeValidate })
        .then((res) => {
          if (res.code == 200) {
            this.setState({
              current: 2,
              time: 0,
              param: {},
            });
            _get_user_info({ uid, token, qKey: 'ChangePhone' });
            this.props.refresh();
          } else {
            message.error(res.message);
          }
        })
        .finally(() => {
          resetCaptchaVerified();
          this.setState({ loading: false });
        });
    });
  };
  validationData = (nationCode) => {
    const { param } = this.state;
    if (!param.phone) {
      message.warning('请填写手机号码');
      return false;
    }

    if (!Util.validationPhone(param.phone, nationCode)) return;

    return true;
  };
  componentWillUnmount() {
    clearTimeout(this.ttimer);
  }
  // 选择的区号
  selNation = (nation) => {
    this.setState({
      nationCode: nation.code,
      nationVisible: false,
    });
  };
  // 展示隐藏区号
  showNationCode = () => {
    this.setState({ nationVisible: !this.state.nationVisible });
  };

  render() {
    const { base, user } = this.props;
    const { userBindPhoneVo } = user;
    const { rootConfig } = base;
    const { visible, current, loading, time, nationCode, nationVisible } =
      this.state;
    return (
      <Modal
        open={visible}
        wrapClassName="daidai-modal-style has-top-border"
        centered={true}
        title="手机绑定"
        footer={null}
        keyboard={false}
        maskClosable={false}
        width="500px"
        onCancel={this.hideModal}
        destroyOnHidden
      >
        <div className="change-phone-plan">
          <Steps progressDot current={current}>
            <Steps.Step title="身份验证" description="" />
            <Steps.Step title="绑定手机" description="" />
            <Steps.Step title="完成" description="" />
          </Steps>
          {current === 0 && userBindPhoneVo.phone ? (
            <div className="pro-step">
              <div className="form-row">
                <label className="form-label">手机号：</label>
                <div className="form-control form-control-flex">
                  {rootConfig.lang != 'zh_CN' && (
                    <span onClick={this.showNationCode} className="nation-code">
                      +{nationCode}{' '}
                      {nationVisible ? <UpOutlined /> : <DownOutlined />}
                    </span>
                  )}
                  <input
                    className="input-phone"
                    type="text"
                    name="phone"
                    disabled
                    autoComplete="off"
                    placeholder="请输入修改的手机号"
                    defaultValue={Util.getPrivatePhone(
                      userBindPhoneVo.phone,
                      userBindPhoneVo.areaCode
                    )}
                  />
                </div>
              </div>
              <div className="form-row">
                <label className="form-label">短信验证码：</label>
                <div className="form-control">
                  <input
                    placeholder="请输入短信验证码"
                    type="text"
                    name="code"
                    autoComplete="off"
                    onChange={this.changeFormValue}
                    maxLength="6"
                  />
                  <button
                    className="send-code"
                    disabled={time > 0}
                    onClick={this.sendCode}
                  >
                    {time ? `${time}s` : '发送验证码'}
                  </button>
                </div>
              </div>
              <div className="form-row">
                <div className="form-control action">
                  <Button
                    loading={loading}
                    className="daidai-btn-primary"
                    onClick={this.validatePhone}
                  >
                    下一步
                  </Button>
                </div>
              </div>
            </div>
          ) : null}
          {current === 1 ? (
            <div className="pro-step">
              <div className="form-row">
                <label className="form-label">手机号：</label>
                <div className="form-control">
                  {rootConfig.lang != 'zh_CN' && (
                    <span onClick={this.showNationCode} className="nation-code">
                      +{nationCode}{' '}
                      {nationVisible ? <UpOutlined /> : <DownOutlined />}
                    </span>
                  )}
                  <input
                    placeholder="请输入要绑定的手机号"
                    type="text"
                    name="phone"
                    autoComplete="off"
                    onChange={this.changeFormValue}
                  />
                </div>
              </div>
              <div className="form-row">
                <label className="form-label">短信验证码：</label>
                <div className="form-control">
                  <input
                    placeholder="请输入短信验证码"
                    type="text"
                    name="code"
                    autoComplete="off"
                    onChange={this.changeFormValue}
                    maxLength="6"
                  />
                  <Button
                    loading={loading}
                    className="send-code"
                    disabled={time > 0}
                    onClick={this.sendCode}
                  >
                    {time ? `${time}s` : '发送验证码'}
                  </Button>
                </div>
              </div>
              <div className="form-row">
                <div className="form-control action">
                  <Button
                    loading={loading}
                    className="daidai-btn-primary"
                    onClick={this.bindMePhone}
                  >
                    立即绑定
                  </Button>
                </div>
              </div>
            </div>
          ) : null}
          {current === 2 ? (
            <div className="pro-step">
              <div className="success-plan">
                <div className="icon-row">
                  <CheckCircleFilled />
                </div>
                <p>绑定成功</p>
              </div>
            </div>
          ) : null}
        </div>

        {/* 手机号地区选择 */}
        <NationCode
          className="bind-nation-code"
          visible={nationVisible}
          base={base}
          selNation={this.selNation}
        />
      </Modal>
    );
  }
}

export default jxCaptchaVerifiedHOC(withRouter(ChangePhone, { withRef: true }));
